import { render, staticRenderFns } from "./MatrixCheckboxes.vue?vue&type=template&id=63801949"
import script from "./MatrixCheckboxes.vue?vue&type=script&lang=js"
export * from "./MatrixCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports